import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=2c5d7173&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=2c5d7173&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d7173",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5d7173')) {
      api.createRecord('2c5d7173', component.options)
    } else {
      api.reload('2c5d7173', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=2c5d7173&scoped=true", function () {
      api.rerender('2c5d7173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth/ResetPassword.vue"
export default component.exports